// extracted by mini-css-extract-plugin
module.exports = {"popup":"StartPopup_popup__1Po9q","textInfo":"StartPopup_textInfo__305Kj"};